<template>
  <v-sheet
    darkmandatory
    active-class="active-topic"
    class="mt-4 pb-4 pr-2 pt-4"
  >
    <section class="scroll-container">
      <div class="pl-2">
        <p class="text-h6">{{ $t('wb-config.basisdaten.title') }}</p>
        <topic-cloud
          @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
          :topics="[baseDataTopic]"
        />

        <div v-for="section in questionnaireSectionsWithMetadata" :key="`section-id-${section.id}`">
          <p class="text-h6">{{ section.title }}</p>
            <topic-cloud
            @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
            :topics="section.topics"
          />
        </div>
        <p class="text-h6">{{ $t('bf.conclusion') }}</p>
        <topic-cloud
          @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
          :topics="conclusionTopics"
        />
      </div>
    </section>
  </v-sheet>
</template>

<script>
import TopicCloud from './TopicCloud.vue';
import common from '../../../mixins/common';

  export default {
    components: { TopicCloud },
    name: 'BottomSheetTopicNavigation',
    mixins: [common],
    props: {
      value: {
        type: Object,
        required: true
      },
      selectedTopicId: {
        type: String,
        default: 'basedata'
      },
      questionnaire: {
        type: Object,
        required: true
      },
      evaluationType: {
        type: String,
        required: true
      },
    },
    computed: {
      questionnaireSectionsWithMetadata() {
        const mapCompletedToTopics = (section) => {
          return {
            ...section,
            topics: section.topics.map(
              (topic) => {
                return {
                  ...topic,
                  completed: this.questionnaireData.topics[topic.id].completed
                };
              }
            )
          }
        };
        const topicsWithCompleted = this.questionnaire.sections.map(mapCompletedToTopics);
        return topicsWithCompleted;
      },
      questionnaireData() {
        return this.value;
      },
      baseDataTopic() {
        return {
          id: 'basedata',
          value: 'basedata',
          title: this.$t('bf.informationData'),
          completed: this.questionnaireData.baseData.completed
        };
      },
      noteTopic() {
        return {
          id: 'note',
          value: 'note',
          title: this.$t('fahrdienst452.comment'),
          completed: !!this.questionnaireData.note
        };
      },
      overallGradeTopic() {
        return {
          id: 'overallGrade',
          value: 'overallGrade',
          title: this.$t('bf.overallGrade'),
          completed: false
        };
      },
      reviewTopic() {
      return {
          id: 'review',
          value: 'review',
          title: this.$t('bf.review'),
          completed: false
        };
      },
      completeTopic() {
        return {
          id: 'complete',
          value: 'complete',
          title: this.$t('begleitfahrt.complete'),
          completed: false,
        }
      },
      /**
       * @return {{id: string, completed: boolean, title: VueI18n.TranslateResult, value: string}[]}
       */
      conclusionTopics() {
        let conclusionTopics = [ this.noteTopic ];
        if(
          this.questionnaire.isType
          && this.questionnaire.isType === this.evaluationType
        ) {
          conclusionTopics.push( this.overallGradeTopic );
        } else {
          conclusionTopics.push( this.reviewTopic );
        }
        conclusionTopics.push( this.completeTopic )
        return conclusionTopics;
      }
    }
  };
</script>

<style scoped>
  p.text-h6 {
    font-size: 1rem !important;
    margin: 0 0 0.2rem 0.7rem;
  }
</style>